module.exports = __webpack_public_path__ + "img/Foreground_Right.3c680b70.svg";